import { useAuth0 } from '@sparkai/auth'
import { LoadingMessage } from '@sparkai/auth/src/components/LoadingMessage'
import { Navigate } from 'react-router-dom-v5-compat'

export function Fallback() {
  const { isAuthenticated } = useAuth0()

  const pathname = window.location.pathname
  const returnTo = pathname !== '/' ? pathname : undefined

  if (isAuthenticated) {
    return <Navigate to='/redirect' replace state={returnTo ? { returnTo } : undefined} />
  }

  return <LoadingMessage />
}
